export default __webpack_public_path__ + "static/media/B_Kevin.5869cb38.jpg";